import { render, staticRenderFns } from "./ResetNewPasswordUser.vue?vue&type=template&id=d061e606&scoped=true"
import script from "./ResetNewPasswordUser.vue?vue&type=script&lang=js"
export * from "./ResetNewPasswordUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d061e606",
  null
  
)

export default component.exports